import React, { useReducer, useCallback } from 'react';
import ChooseAmount from './components/ChooseAmount';
import LabelWithInput from './components/LabelWithInput';

const getDefaultAmount = () => {
  const DEFAULT = 55;
  try {
    // eslint-disable-next-line no-restricted-globals
    const requested = (new URLSearchParams(location.search)).get('amount');
    const parsed = parseInt(requested, 10);
    if (parsed > 4) {
      return parsed;
    }
    throw new Error('Invalid amount');
  } catch (error) {
    return DEFAULT;
  }
};

const defaultForm = {
  amount: getDefaultAmount(),
  firstname: '',
  lastname: '',
  postcode: '',
  street: '',
  city: '',
  email: '',
  newsletter: false,
};

const reducer = (state, action) => {
  const [name, value] = action;

  return {
    ...state,
    [name]: value,
  };
};

const showError = () => {
  // Yes, native alerts are not that bad. Later would be nice to implement some feedback
  // pattern.
  alert('Ups, coś poszło nie tak. Spróbuj ponownie później lub skontaktuj się z nami, jeśli problem dalej występuje.');
};

const PaymentFormPage = () => {
  const [form, dispatchForm] = useReducer(reducer, defaultForm);
  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    // eslint-disable-next-line no-undef
    fetch('/api/checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(form),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.redirectUri) {
          console.error('Invalid response', response);
          showError();
          return;
        }

        location.href = response.redirectUri;
      })
      .catch((error) => {
        console.error('Checkout failed', error);
        showError();
      });
  }, [form]);

  return (
    <div className="layout layout--middle">
      <form action="#" onSubmit={handleSubmit} className="form paper">
        <ChooseAmount value={form.amount} onChange={dispatchForm} />
        <LabelWithInput
          type="number"
          value={form.amount}
          min="5"
          text="Wybrana kwota"
          required
          name="amount"
          onChange={dispatchForm}
        />
        <LabelWithInput
          text="Imię"
          value={form.firstname}
          name="firstname"
          onChange={dispatchForm}
          required
        />
        <LabelWithInput
          text="Nazwisko"
          value={form.lastname}
          name="lastname"
          onChange={dispatchForm}
          required
        />
        <LabelWithInput
          text="Email"
          value={form.email}
          name="email"
          onChange={dispatchForm}
        />
        <LabelWithInput
          text="Ulica i numer"
          value={form.street}
          name="street"
          onChange={dispatchForm}
          required
        />
        <LabelWithInput
          text="Kod pocztowy"
          value={form.postcode}
          name="postcode"
          onChange={dispatchForm}
          required
        />
        <LabelWithInput
          text="Miasto"
          value={form.city}
          name="city"
          onChange={dispatchForm}
          required
        />
        <LabelWithInput
          text="Kraj"
          value="Polska"
          name="country"
          disabled="disabled"
          onChange={() => {}}
          required
        />
        <LabelWithInput
          text="Chcę otrzymywać newsletter Razem."
          footer="Wyrażam zgodę na przetwarzanie adresu email w celu otrzymywania wiadomości od partii Razem, informacji o jej działaniach oraz kampaniach. Zgoda może być wycofana w każdej chwili."
          checked={!!form.newsletter}
          type="checkbox"
          name="newsletter"
          onChange={dispatchForm}
        />
        <p className="payment-disclaimer">
          Wpłaty mogą być dokonywane wyłącznie przez osoby fizyczne mające stałe miejsce zamieszkania w Polsce i posiadające polskie obywatelstwo. Wpłaty
          można realizować jedynie przelewem bankowym z konta osobistego (nie firmowego) i muszą one zawierać imię i nazwisko wpłacającego oraz jego dokładny adres zamieszkania.
          <br />
          <br />
          Łączna suma wpłat na cele statutowe nie może przekroczyć <strong>69&nbsp;990 zł na osobę w ciągu roku kalendarzowego</strong>.
          <br />
          <br />
          <a href="/regulamin" target="__blank">
            Regulamin darowizn na cele statutowe Partii Razem.
          </a>
          <br />
          <a href="https://static.partiarazem.pl/razem-static/docu/Statut.pdf" target="_blank" rel="noreferrer">Statut Partii Razem</a>.
          <br />
          <br />
          Administratorem danych osobowych jest Partia Razem z siedzibą ul. Nowy Świat 27,
          {' '} 00-029 Warszawa.
          Dane podane w formularzu będą przetwarzane w celu spełnienia obowiązku prowadzenia
          {' '} dokumentacji księgowej zgodnie z zasadami określonymi w naszej
          {' '}
          <a href="https://partiarazem.pl/polityka-prywatnosci/" rel="noreferrer" target="_blank">Polityce prywatności</a>.
        </p>
        <button
          type="submit"
          className="button"
          style={{
            gridArea: 'submit',
          }}
        >
          Płatność z PayU
        </button>
      </form>
    </div>
  );
};

export default PaymentFormPage;
